const get24Hours = () => {
  const hours = [];
  for (let i = 1; i < 24; i += 1) {
    hours.push(`${i}:00`);
  }
  return hours;
};

const reverseDayMonth = (string) => {
  const split = string.split('.');
  const value = [
    split[1],
    split[0],
    split[2],
  ];
  return value.join('.');
};

/**
 * @description
 * Compares two objects according to their keys,
 * and returns true if the data is different.
 * If the data is the same, it returns false.
 *
 * @example
 * Namespace.comparison(obj1, obj2);
 *
 * @param {object} obj1
 * @param {object} obj2
 * @return {boolean}
 */

const comparison = (obj1, obj2) => {
  const keys = Object.keys(obj1);

  for (let i = 0; i < keys.length; i += 1) {
    const val1 = obj1[keys[i]];
    const val2 = obj2[keys[i]];
    if (val1 !== val2) return true;
  }

  return false;
};

/**
 * @description
 * Returns only the time in the given date object.
 * The answer will be in the following format: H:m
 *
 * @example
 * const date = new Date();
 * Namespace.getTime(date);
 *
 * @param { Object } date
 * @return {string}
 */

const getTime = (date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}`;
};

/**
 * @description
 * Returns the whole time in the given date object.
 * The answer will be in the following format: H:m:s
 *
 * @example
 * const date = new Date();
 * Namespace.getFullTime(date);
 *
 * @param {Object} date
 * @return {string}
 */

const getFullTime = date => `${getTime(date)}:${date.getSeconds()}`;

/**
 * @description
 * Returns only the date in the given date object.
 * The answer will be in the following format: d:M:YYYY
 *
 * @example
 * const date = new Date();
 * Namespace.getDate(date);
 *
 * @param {Object} date
 * @return {string}
 */

const getDate = date => `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;

/**
 * @description
 * It will return today's history as an answer.
 * The answer will be in the following format: d:M:YYYY H: m: s
 *
 * @example
 * const date = new Date();
 * Namespace.getDate(date);
 *
 * @return {string}
 */

const getToday = () => {
  const date = new Date();
  return `${getDate(date)} ${getFullTime(date)}`;
};

export default {
  comparison,
  get24Hours,
  getDate,
  getFullTime,
  getTime,
  getToday,
  reverseDayMonth,
};
